export default {
  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage: 'https://img1.wsimg.com/isteam/ip/6c6de2cb-d735-4503-bc47-4990c06ed584/AdobeStock_103208570.jpeg',
  drawer: null,
  callingAPI: false,
  searching: '',
  general: {
    localeCode: 'en-GB',
    currency: 'GBP',
    symbol: '£',
  },
  settings: {
    general: {
      localeCode: 'en-GB',
      currency: 'GBP',
      symbol: '£',
    },
    comment: {
      width: 1200,
      flapWidth: 180,
    },
    flap: {
      width: {
        default: 180,
        extra: 220,
        long: 195,
      },
    },
    weeks: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    date: {
      serverFormatDate: 'YYYY-MM-DD',
      serverFormatDatetime: 'YYYY-MM-DD HH:mm:ss',
      clientFormatDate: 'DD-MM-YYYY',
    },
    url: {
      speed: '/images/speed',
      weather: '/images/weather',
      logo: '/images/id-short-logo.png',
    },
  },
  tableSettings: [],
}
